import { inject } from 'aurelia-dependency-injection';
import { customAttribute } from 'aurelia-templating';
// eslint-disable-next-line import/no-unassigned-import
import './draggable-dialog.scss';

@inject(Element)
@customAttribute('draggable-dialog')
export class DraggableDialog implements EventListenerObject {
  constructor(private element: HTMLElement) { }

  title: HTMLElement;
  surface: HTMLElement;
  offsetX: number;
  offsetY: number;
  pointerId?: number;

  attached() {
    this.element.classList.add('mdc-dialog--draggable');
    this.title = this.element.querySelector<HTMLElement>('.mdc-dialog__title');
    this.title.addEventListener('pointerdown', this);
    this.surface = this.element.querySelector<HTMLElement>('.mdc-dialog__surface');
  }

  detached() {
    this.title.removeEventListener('pointerdown', this);
    this.handlePointerUp();
  }

  handleEvent(event: Event): void {
    switch (event.target) {
      case this.title:
        switch (event.type) {
          case 'pointerdown': this.handlePointerDown(event as PointerEvent); break;
          case 'pointerup': this.handlePointerUp(); break;
          case 'pointermove': this.handlePointerMove(event as PointerEvent); break;
        }
        break;
    }
  }

  handlePointerDown(e: PointerEvent) {
    this.pointerId = e.pointerId;
    this.title.setPointerCapture(e.pointerId);
    this.offsetX = e.offsetX;
    this.offsetY = e.offsetY;
    this.title.addEventListener('pointermove', this, { capture: true });
    this.title.addEventListener('pointerup', this, { capture: true });
  }

  handlePointerUp() {
    if (this.pointerId) {
      this.title.releasePointerCapture(this.pointerId);
      this.pointerId = undefined;
    }
    this.title.removeEventListener('pointermove', this, { capture: true });
    this.title.removeEventListener('pointerup', this, { capture: true });
  }

  handlePointerMove(e: PointerEvent) {
    this.surface.style.top = `${e.clientY - this.offsetY}px`;
    this.surface.style.left = `${e.clientX - this.offsetX}px`;
  }
}
